import { system } from 'styled-system';
import { baseTheme } from '../../styles'; // Props that should not be forwarded to the HTML DOM elements

export var shouldForwardProp = function shouldForwardProp(prop, defaultValidationFn) {
  return !['height', 'width', 'color', 'display'].includes(prop) && defaultValidationFn(prop);
};
/**
 * Only define the parent grid attributes because the other grid items are already defined on the Box component.
 */

export var grid = system({
  gridGap: {
    property: 'gridGap',
    scale: 'space',
    defaultScale: baseTheme.space
  },
  gridColumnGap: {
    property: 'gridColumnGap',
    scale: 'space',
    defaultScale: baseTheme.space
  },
  gridRowGap: {
    property: 'gridRowGap',
    scale: 'space',
    defaultScale: baseTheme.space
  },
  gridAutoFlow: true,
  gridAutoColumns: true,
  gridAutoRows: true,
  gridTemplateColumns: true,
  gridTemplateRows: true,
  gridTemplateAreas: true
});